import { baseErrorHandler } from "@queries/baseErrorHandler";
import { $api } from "@service/RequestService";
import { BossHeader } from "@utils/models/BossHome";
import { stringifyUrl } from "query-string";
import { useQuery } from "react-query";
import { StringParam, useQueryParams } from "use-query-params";

import { queryKeys } from "../constants";

export function useBalanceCardsBoss() {
    const [query] = useQueryParams({
        houses: StringParam,
        buildings: StringParam
    })

    return useQuery<BossHeader>(
        [queryKeys.BOSS_HEADER_CARDS, query],
        async () => {
            const res = await Promise.all([
                $api.get(stringifyUrl({
                    url: `/v1/mobile/indebtedness/month`, query
                })),
                $api.get(stringifyUrl({
                    url: `/v1/mobile/indebtedness/all`, query
                })),
                $api.get(`/v1/mobile/client/balance`)
            ]);

            return {
                balance: res[2].data.data,
                all: res[1].data.data,
                month: res[0].data.data
            };
        },
        {
            refetchOnWindowFocus: false,
            onError: baseErrorHandler,
            retry: false
        }
    );
}